import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';
import { MultiBuyerStateService } from '../services/multi-buyer/multi-buyer-state.service';
import { AccessControlConfig } from '../services/multi-buyer/interfaces/multi-buyer-company.interface';

@Injectable({ providedIn: 'root' })
export class MasterMultiBuyerRedirectGuard implements CanActivate {
  constructor(
    private readonly _auth: AuthService,
    private readonly _multiBuyerState: MultiBuyerStateService,
    private readonly _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const config = this._multiBuyerState.accessControlConfig;
    const config$ =
      config.userRole === undefined ? this._resolveConfig() : of(config);

    return config$.pipe(
      take(1),
      map((resolved) => {
        const enableTemplate = this._auth.buyerConfig?.enableTemplate ?? false;
        const isMaster = resolved.userRole === 'masterMultiBuyer';
        const canAccess = resolved.capabilities.canAccessMasterTemplate;

        if (isMaster && enableTemplate && canAccess) {
          return this._router.parseUrl('/create-templates');
        }
        return true;
      })
    );
  }

  private _resolveConfig(): Observable<AccessControlConfig> {
    const user = this._auth.user!;
    const userRole = this._auth.getMultiBuyerRole(user);

    if (!userRole) {
      return of(this._multiBuyerState.accessControlConfig);
    }

    return this._multiBuyerState
      .getAccessControlConfig(user.cmp, userRole)
      .pipe(tap((cfg) => this._multiBuyerState.setAccessControlConfig(cfg)));
  }
}
